const ACCESS_TOKEN_KEY = "accessToken";
const REFRESH_TOKEN_KEY = "refreshToken";

function safeGetItem(key) {
  if (typeof window === "undefined" || !window.localStorage) {
    return null;
  }
  try {
    return window.localStorage.getItem(key);
  } catch (error) {
    console.warn("Impossible de lire le stockage local", error);
    return null;
  }
}

function safeSetItem(key, value) {
  if (typeof window === "undefined" || !window.localStorage) {
    return;
  }
  try {
    if (value === null || value === undefined) {
      window.localStorage.removeItem(key);
    } else {
      window.localStorage.setItem(key, value);
    }
  } catch (error) {
    console.warn("Impossible d'écrire dans le stockage local", error);
  }
}

export function loadTokensFromStorage() {
  return {
    access: safeGetItem(ACCESS_TOKEN_KEY),
    refresh: safeGetItem(REFRESH_TOKEN_KEY),
  };
}

export function getAccessToken() {
  return safeGetItem(ACCESS_TOKEN_KEY);
}

export function getRefreshToken() {
  return safeGetItem(REFRESH_TOKEN_KEY);
}

export function setTokens({ access, refresh }) {
  if (typeof access !== "undefined") {
    safeSetItem(ACCESS_TOKEN_KEY, access ?? null);
  }

  if (typeof refresh !== "undefined") {
    safeSetItem(REFRESH_TOKEN_KEY, refresh ?? null);
  }
}

export function clearTokens() {
  safeSetItem(ACCESS_TOKEN_KEY, null);
  safeSetItem(REFRESH_TOKEN_KEY, null);
}

export default {
  loadTokensFromStorage,
  getAccessToken,
  getRefreshToken,
  setTokens,
  clearTokens,
};
